// АВТОГЕНЕРИРОВАННЫЙ ФАЙЛ — НЕ РЕДАКТИРУЙТЕ ВРУЧНУЮ.
// Источник правды: data-source/korpy_balance_v6.xlsx
// Регенерация: npm run gen-cards (или двойной клик по tools/gen-cards.bat)
// Сгенерировано: 2026-06-03T21:08:21.157Z

export const heroes = [
  {
    "id": "global_iv",
    "name_ru": "Майор Ив",
    "name_en": "Major Ivy",
    "faction": "global",
    "type": "hero",
    "rarity": "special",
    "archetype": "Хилер-командир",
    "exclusive_hero": null,
    "atk": 3,
    "armor": 3,
    "hp": 10,
    "keywords": [],
    "priority_override": null,
    "global_choices": [],
    "influence_cost": null,
    "mod_target": null,
    "initiation": null,
    "deck_limit": 1,
    "recycle_value": null,
    "nft_threshold": null,
    "price_usdt": null,
    "price_scripts": null,
    "ability_short": null,
    "ability_text": {
      "active": "1× за матч: все союзные юниты получают +2 max_armor (с синхронным +2 current) до конца игры",
      "trigger": "В конце своего хода: если на поле есть союзный Боец G-Sec — все союзные юниты лечатся на 1 hp"
    },
    "dsl_order": null,
    "dsl_deathrattle": null,
    "dsl_trigger1": {
      "event": "turn_end",
      "target": "ally_aoe_all",
      "effect": "heal",
      "value": "1",
      "condition": "own_field_has_gsec_fighter"
    },
    "dsl_trigger2": null,
    "dsl_active": {
      "target": "ally_aoe_all",
      "effect": "buff_stats",
      "value": "0/2/0",
      "duration": "permanent",
      "uses": "1"
    },
    "dsl_aura": null,
    "flavor_ru": "«Каждый солдат — инвестиция. Я не теряю инвестиции.»",
    "ability_text_en": {
      "active": "1× per match: all allied units get +2 max armor (with a synchronous +2 current) for the rest of the game",
      "trigger": "At the end of your turn: if there is an allied G-Sec Trooper on the field, all allied units heal 1 hp"
    }
  },
  {
    "id": "global_li_pul",
    "name_ru": "Стратег Ли Пул",
    "name_en": "Strategist Li Pool",
    "faction": "global",
    "type": "hero",
    "rarity": "special",
    "archetype": "Мобильность",
    "exclusive_hero": null,
    "atk": 1,
    "armor": 3,
    "hp": 11,
    "keywords": [],
    "priority_override": null,
    "global_choices": [],
    "influence_cost": null,
    "mod_target": null,
    "initiation": null,
    "deck_limit": 1,
    "recycle_value": null,
    "nft_threshold": null,
    "price_usdt": null,
    "price_scripts": null,
    "ability_short": null,
    "ability_text": {
      "active": "1× за матч: 2 следующих хода никто не атакует (ни юниты, ни Герои). Ф1 (тяга) играется. Ф2 (размещение) играется. Ф3 разрешает Действия и Приказы, но автоатаки пропускаются. Ф4/Ф5 пропускаются",
      "trigger": "В начале своего хода: передвинуть любого юнита (свой или вражеский) на свободную ячейку в пределах его стороны"
    },
    "dsl_order": null,
    "dsl_deathrattle": null,
    "dsl_trigger1": {
      "event": "turn_start",
      "target": "any_unit_within_own_side",
      "effect": "move",
      "value": "any_free_cell_within_own_side"
    },
    "dsl_trigger2": null,
    "dsl_active": {
      "target": "self",
      "effect": "freeze",
      "value": "2",
      "uses": "1"
    },
    "dsl_aura": null,
    "flavor_ru": "«Война — это не атаки. Война — это позиции.»",
    "ability_text_en": {
      "active": "1× per match: for the next 2 turns no one attacks (neither units nor Heroes). Phase 1 (draw) plays. Phase 2 (placement) plays. Phase 3 allows Actions and Orders, but auto-attacks are skipped. Phases 4/5 are skipped",
      "trigger": "At the start of your turn: move any unit (yours or enemy) to a free slot within its own side"
    }
  },
  {
    "id": "global_mit",
    "name_ru": "Полковник Мит",
    "name_en": "Colonel Mitt",
    "faction": "global",
    "type": "hero",
    "rarity": "special",
    "archetype": "Зерг G-Sec",
    "exclusive_hero": null,
    "atk": 2,
    "armor": 3,
    "hp": 11,
    "keywords": [],
    "priority_override": null,
    "global_choices": [],
    "influence_cost": null,
    "mod_target": null,
    "initiation": null,
    "deck_limit": 1,
    "recycle_value": null,
    "nft_threshold": null,
    "price_usdt": null,
    "price_scripts": null,
    "ability_short": null,
    "ability_text": {
      "active": "1× за матч: призвать 4 Бойцов G-Sec, каждого на случайную свободную ячейку своей стороны",
      "trigger": "В конце хода матча, если номер хода кратен 3 (ходы 3, 6, 9, …): призыв Бойца G-Sec на свободную ячейку 1-й линии (если полная — на 2-ю)"
    },
    "dsl_order": null,
    "dsl_deathrattle": null,
    "dsl_trigger1": {
      "event": "turn_end",
      "target": "own_line",
      "effect": "summon",
      "value": "global_gsec_fighter",
      "condition": "turn_number_multiple_of_3"
    },
    "dsl_trigger2": null,
    "dsl_active": {
      "target": "random_empty_slots",
      "effect": "summon",
      "value": "global_gsec_fighter@count:4",
      "uses": "1"
    },
    "dsl_aura": null,
    "flavor_ru": "«Линию держать. Один за всех — все за корпорацию.»",
    "ability_text_en": {
      "active": "1× per match: summon 4 G-Sec Troopers, each to a random free slot on your side",
      "trigger": "At the end of a turn, if the turn number is a multiple of 3 (turns 3, 6, 9, …): summon a G-Sec Trooper to a free slot on line 1 (if full, on line 2)"
    }
  },
  {
    "id": "global_rayna",
    "name_ru": "«Дирижёр» Райна",
    "name_en": "\"Conductor\" Rayna",
    "faction": "global",
    "type": "hero",
    "rarity": "special",
    "archetype": "Усилитель Подавления",
    "exclusive_hero": null,
    "atk": 2,
    "armor": 3,
    "hp": 10,
    "keywords": [],
    "priority_override": null,
    "global_choices": [],
    "influence_cost": null,
    "mod_target": null,
    "initiation": null,
    "deck_limit": 1,
    "recycle_value": null,
    "nft_threshold": null,
    "price_usdt": null,
    "price_scripts": null,
    "ability_short": null,
    "ability_text": {
      "active": "1× за матч: выдать keyword «Подавление» одному выбранному союзному Глобал-юниту до конца матча",
      "trigger": "Когда выставляется союзный Глобал-юнит с keyword Подавление: пока этот юнит жив, его эффект Подавления удваивается на той же ячейке (на 1-й −2 атаки, на 2-й Молчание на 3 хода)"
    },
    "dsl_order": null,
    "dsl_deathrattle": null,
    "dsl_trigger1": {
      "event": "ally_summoned",
      "filter": "has_keyword_suppression",
      "target": "event_subject",
      "effect": "amplify_suppression",
      "duration": "while_alive"
    },
    "dsl_trigger2": null,
    "dsl_active": {
      "target": "ally_choose",
      "effect": "give_keyword",
      "keyword": "suppression",
      "duration": "permanent",
      "uses": "1"
    },
    "dsl_aura": null,
    "flavor_ru": "«Огонь — это симфония. И я знаю, кто играет первую скрипку.»",
    "ability_text_en": {
      "active": "1× per match: grant the «Suppression» keyword to one chosen allied Global unit for the rest of the match",
      "trigger": "When an allied Global unit with the Suppression keyword is deployed: while this unit is alive, its Suppression effect is doubled on the same slot (line 1: −2 attack; line 2: Silence for 3 turns)"
    }
  }
];
